/**
 * @overview Display a loading animation which overlays an element.
 *
 * @module loader
 */

/**
 * Checks whether an object is an Array type.
 *
 * @param {Object} obj
 * @returns {boolean}
 */
const isArrayType = (obj) => obj && obj.length;

const loadingClass = 'is-loading';
const modifierClasses = {
    fixed: `${loadingClass}--fixed`,
    opaque: `${loadingClass}--bgFade`,
    small: `${loadingClass}--small`,
    light: `${loadingClass}--light`,
    dark: `${loadingClass}--dark`
};

/**
 * Adds the loader class to an element.
 *
 * @param {Node} element
 * @param {boolean} isPositionFixed
 */
function addLoader (element, options) {
    if (element && element.classList) {
        element.classList.add(loadingClass);

        if (options.isPositionFixed) {
            element.classList.add(modifierClasses.fixed);
        }
        if (options.isOpaque) {
            element.classList.add(modifierClasses.opaque);
        }
        if (options.isSmall) {
            element.classList.add(modifierClasses.small);
        }
        if (options.isLight) {
            element.classList.add(modifierClasses.light);
        }
        if (options.isDark) {
            element.classList.add(modifierClasses.dark);
        }
    }
}

/**
 * Removes the loader class from an element.
 *
 * @param {Node} element
 */
function removeLoader (element) {
    if (element && element.classList) {
        element.classList.remove(loadingClass);

        for (const className in modifierClasses) {
            element.classList.remove(modifierClasses[className]);
        }
    }
}

/**
 * Displays the loader over an element.
 *
 * @param {Node|NodeList|Array} element
 * @param {Object} options
 */
export function showLoader (element, options = {}) {
    if (isArrayType(element)) {
        for (const el of element) {
            addLoader(el, options);
        }
    } else {
        addLoader(element, options);
    }
}

/**
 * Removes the loader from an element.
 *
 * @param {Node|NodeList|Array} element
 */
export function hideLoader (element) {
    if (isArrayType(element)) {
        for (const el of element) {
            removeLoader(el);
        }
    } else {
        removeLoader(element);
    }
}
